// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__U8CDS","toggle":"checkbox_toggle__PzNV7"};